
import sharedStyles from 'styles/css/SharedStyles.module.scss';
// import styles from 'styles/css/Main.module.scss';
// import drawerStyles from 'styles/css/Drawer.module.scss';
// import actionStyles from 'styles/css/ActionStyles.module.scss';
// import Logo from 'styles/images/logo/logo512.png';

import ShortHeaderWithBackBtnNameOfGod from 'components/root/partials/header/ShortHeaderWithBackBtnNameOfGod';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';

const Bylaws = () => {

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtnNameOfGod />

                

                <div className={[formStyles.title, formStyles['text-center'], sharedStyles['text-red']].join(' ')}>
                    اساسنامه دکتربیست
                </div>
                
                <p className={[ruleStyles['text-justify'], sharedStyles['text-primary']].join(' ')}>
                    انشاالله، شرکت سهامی خاص فناوران و نوآوران دکتربیست در سه فیلد فعالیت میکد:
                </p>
                <p className={[ruleStyles['text-justify'], sharedStyles.flex, sharedStyles['flex-col'], sharedStyles['text-primary']].join(' ')}>
                    ۱ -مشاوره پزشکی و صدور نسخه الکترونیک
                    <br />
                    <span className={[sharedStyles['w-full'] ,sharedStyles['text-left'], sharedStyles['dir-ltr']].join(' ')}>(Medical Consultation & Electronic Prescription)</span>
                </p>
                <p className={[ruleStyles['text-justify'], sharedStyles.flex, sharedStyles['flex-col'], sharedStyles['text-primary']].join(' ')}>
                    ۲-توریسم درمانی سازمان یافته و حرفه ای
                    <br />
                    <span className={[sharedStyles['w-full'] ,sharedStyles['text-left']].join(' ')}>(Organized & Professional Medical Tourism)</span>
                </p>
                <p className={[ruleStyles['text-justify'], sharedStyles['text-primary']].join(' ')}>
                    ۳- شاپینگ سنتر  Shopping Center
                    <br />
                    دارو (عمدتا گیاهی)و تجهیزات پزشکی برند (با اولویت ساخت داخل کشور عزیزمان ایران)
                </p>
                

                <p className={ruleStyles['text-justify']}>
                    لازم به ذکراست که استارتاپ Dr20,  به لطف خداوند سبحان، در دو فیلد اول و دوم  فوق الذکر، عنوان پرافتخار <span className={sharedStyles['text-green']}>اولین استارتاپ</span> کشور عزیزمان ایران را در کارنامه ی خود دارد.
                </p>


                <div className={[formStyles.title, formStyles['text-center'], sharedStyles['text-red']].join(' ')}>
                    هدف اساسی دکتربیست Dr20 
                </div>
                <p className={ruleStyles['text-justify']}>
                    خداوند سبحان، در سوره مبارکه ضحی، آیه شریفه ۴ میفرماید:
                    <br />
                    "وللآخره خیر لک من الاولی"
                    <br />
                    "وقطعا سرای آخرت، برای تو از دنیا، نیکوتر خواهد بود"..
                    <br />
                </p>
                <p className={ruleStyles['text-justify']}>
                    استاد بیان، سعدی شیرین سخن هم چنین سروده است:
                    <br />
                    <div className={[sharedStyles.flex, sharedStyles.justifyBetween].join(' ')}>
                        <span>نام نیکو گربماند زآدمی</span>
                        <span>به کزو ماند سرای زرنگار</span>
                    </div>
                </p>


                <p className={ruleStyles['text-justify']}>
                    به همین دلیل انشاالله  قسمت عمده‌ی سود خالص   دکتربیست صرف امورخیریه از قبیل:
                    <br />
                    ساخت دارالقرآن الکریم ، مسجد، کتابخانه، اقامتگاه همراه بیمار، فود استور جهت خانواده های ایتام و بی سرپرست و ...(به نام مبارک حضرت علی ابن ابیطالب صلوات الله و سلامه علیه) خواهد شد.
                </p>
                
            </div>
                
        </div>

    );
}

export default Bylaws;